import { useHasStaffTimesheets } from './use-has-staff-timesheets';
import { useUserRole } from './use-user-role';
export function useIsAdmin(options) {
    const role = useUserRole(options);
    const { data: hasStaffTimesheets } = useHasStaffTimesheets(options);
    return role === 'admin' || hasStaffTimesheets || false;
}
//# sourceMappingURL=use-is-admin.js.map